import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../routes';
import NappLogo from '../components/logo';
import { CancelSignupLink } from './signup.page';
const PasswordForgetPage = () => (
  <div className="sign_in__container">
    <NappLogo />
    <h1 style={{ color: 'white' }}>Glemt passord</h1>
    <div style={{ backgroundColor: 'white', padding: 20, borderRadius: 5 }}>
      <PasswordForgetForm />
      <div style={{ textAlign: 'center', marginTop: 20, marginBottom: 30 }}><Link to={ROUTES.SIGN_IN}>Tilbake til innlogging</Link></div>
      <CancelSignupLink />
    </div>
  </div>
);
const INITIAL_STATE = {
  email: '',
  error: null,
};
class PasswordForgetFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }
  onSubmit = event => {
    const { email } = this.state;
    this.props.firebase
      .passwordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
      })
      .catch(error => {
        this.setState({ error });
      });
    event.preventDefault();
  };
  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  render() {
    const { email, error } = this.state;
    const isInvalid = email === '';
    return (
      <form onSubmit={this.onSubmit} className="form">
        <input
          name="email"
          value={this.state.email}
          onChange={this.onChange}
          type="text"
          placeholder="E-postadresse"
        />
        <button disabled={isInvalid} type="submit" className="button button-primary">
          Nullstill passord
        </button>
        {error && <p>{error.message}</p>}
      </form>
    );
  }
}
const PasswordForgetLink = () => (
  <p>
    <Link to={ROUTES.PASSWORD_FORGET}>Glemt passord?</Link>
  </p>
);
export default PasswordForgetPage;
const PasswordForgetForm = withFirebase(PasswordForgetFormBase);
export { PasswordForgetForm, PasswordForgetLink };